window.Products.HomeDecor.DuvetCoverTwin = function() {};
window.Products.HomeDecor.DuvetCoverTwin.inherits(window.Products.HomeDecor.DuvetCover);
window.Products.HomeDecor.DuvetCoverTwin.has_3d = true;
window.Products.HomeDecor.DuvetCoverTwin.id = '86-twin';
window.Products.HomeDecor.DuvetCoverTwin.saveId = 86;
window.Products.HomeDecor.DuvetCoverTwin.slug = 'duvet-cover-twin';
window.Products.HomeDecor.DuvetCoverTwin.dpi = 150;
window.Products.HomeDecor.DuvetCoverTwin.prototype.designObject = 1;